import type { ListBuilderConfiguration } from '../types';

/**
 * Payment Schedule Occurrences list configuration for the client-level
 * occurrences embedded list. Read-only — occurrences are system-generated.
 */
export const PAYMENT_SCHEDULE_OCCURRENCES_LIST_CONFIG: ListBuilderConfiguration =
	{
		lists: [
			{
				id: 'default-payment-schedule-occurrences',
				cacheTTL: 300000,
				name: 'Payment Schedule Occurrences',
				type: 'default',
				active: true,
				columns: [
					{
						id: 'occurrence-schedule-name',
						headers: [
							{
								id: 'occurrence-schedule-name-header',
								text: 'Schedule',
							},
						],
						fields: [
							{
								id: 'occurrence-schedule-name-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'scheduleName',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'md',
									colorRule: {
										type: 'default',
									},
								},
								displayStyle: 'text',
							},
						],
						sortable: true,
					},
					{
						id: 'occurrence-scheduled-date',
						headers: [
							{
								id: 'occurrence-scheduled-date-header',
								text: 'Scheduled Date',
							},
						],
						fields: [
							{
								id: 'occurrence-scheduled-date-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'scheduledDate',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'default',
									},
								},
								displayStyle: 'date',
							},
						],
						sortable: true,
					},
					{
						id: 'occurrence-amount',
						headers: [
							{
								id: 'occurrence-amount-header',
								text: 'Amount',
							},
						],
						fields: [
							{
								id: 'occurrence-amount-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'amount',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'default',
									},
									formatOptions: {
										numberFormat: 'currency',
									},
								},
								displayStyle: 'number',
							},
						],
						sortable: true,
					},
					{
						id: 'occurrence-status',
						headers: [
							{
								id: 'occurrence-status-header',
								text: 'Status',
							},
						],
						fields: [
							{
								id: 'occurrence-status-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'status',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'status_map',
										statusMap: {
											pending: { type: 'info' },
											processing: { type: 'warning' },
											succeeded: { type: 'success' },
											failed: { type: 'danger' },
											skipped: { type: 'default' },
											cancelled: { type: 'default' },
										},
									},
								},
								displayStyle: 'badge',
							},
						],
						sortable: true,
					},
					{
						id: 'occurrence-invoice',
						headers: [
							{
								id: 'occurrence-invoice-header',
								text: 'Invoice',
							},
						],
						fields: [
							{
								id: 'occurrence-invoice-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'invoiceExternalId',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'default',
									},
								},
								displayStyle: 'text',
							},
						],
						sortable: false,
					},
					{
						id: 'occurrence-executed-date',
						headers: [
							{
								id: 'occurrence-executed-date-header',
								text: 'Executed',
							},
						],
						fields: [
							{
								id: 'occurrence-executed-date-field',
								dataConfig: {
									type: 'field',
									field: {
										fieldName: 'executedDate',
										objectTable: 'payment_schedule_occurrence',
									},
								},
								styleConfig: {
									size: 'sm',
									colorRule: {
										type: 'default',
									},
								},
								displayStyle: 'date',
							},
						],
						sortable: true,
					},
				],
				defaultSortId: 'occurrence-scheduled-date-desc',
				sortOrder: 0,
			},
		],
		// The tableSort id must match the list's `defaultSortId` exactly —
		// the sort resolver looks defaultSortId up here (none of the columns
		// carry sortFields, so there is no column-sort to fall back to).
		tableSorts: [
			{
				id: 'occurrence-scheduled-date-desc',
				name: 'Scheduled Date (Newest First)',
				fields: [
					{
						objectTable: 'payment_schedule_occurrence',
						fieldName: 'scheduledDate',
						direction: 'DESC',
					},
				],
			},
		],
		paging: {
			defaultPageSize: 25,
			pageSizeOptions: [10, 25, 50],
		},
		filters: {
			activeFilters: [],
			defaultFilters: {},
		},
		objects: [
			{
				objectLabel: 'Payment Schedule Occurrence',
				objectTable: 'payment_schedule_occurrence',
				selectedFields: [
					{ fieldName: 'id', fieldLabel: 'ID' },
					{ fieldName: 'scheduleName', fieldLabel: 'Schedule' },
					{ fieldName: 'scheduledDate', fieldLabel: 'Scheduled Date' },
					{ fieldName: 'amount', fieldLabel: 'Amount' },
					{ fieldName: 'status', fieldLabel: 'Status' },
					{ fieldName: 'invoiceExternalId', fieldLabel: 'Invoice' },
					{ fieldName: 'executedDate', fieldLabel: 'Executed' },
				],
			},
		],
	};
